export default __webpack_public_path__ + "static/media/cta-img.71f8ab36.jpg";